export default __webpack_public_path__ + "static/media/highlightImageBackground.2e87d5da.svg";